import popupBackgroundImg from './popup_background.png';
import './RewardPopup.css';

type RewardPopupProps = {
  text: string;
};

/** From Figma Group 1321317895 (142:17480) — reward speech bubble. */
export function RewardPopup({ text }: RewardPopupProps) {
  return (
    <div className="sticker-reward-popup" role="status">
      <img
        className="sticker-reward-popup__background"
        src={popupBackgroundImg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <p className="sticker-reward-popup__text">{text}</p>
    </div>
  );
}
